import { datadogRum } from '@datadog/browser-rum'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'

import { sendToApp } from 'scripts/react-components/utils/app/tracker'
import { pushDataObject } from 'scripts/utils/data-layer'

import request from 'catalog/utils/axios'

const BANNER_INSTALL_APP_STORAGE_NAME = '@app:dateLatestCloseBannerInstallApp'
const COMPLETED_JOURNEY_STORAGE_KEY_NAME = '@app:completedAppInstallationCampaign'

const pageIsHome = () => {
  const { pathname } = window.location
  return pathname === '/'
}

const pageIsPdp = () => {
  const { pathname } = window.location
  return /[^\/]+[_]\d+/.test(pathname)
}

const pageIsAllwed = () => {
  return pageIsHome() || pageIsPdp()
}

const sumMinutesToDate = (date: Date, minutes: number) => {
  return new Date(date.setMinutes(minutes + date.getMinutes()))
}

const trackClickOnDownloadButton = () => {
  pushDataObject({
    event: 'download_app',
    step_name: 'cashback_click_download_app'
  })
}

const redirectToDownloadApp = (
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  link: string
) => {
  event.preventDefault()
  window.location.replace(link)
}

const mustDisplayBannerAgain = (timeToShowBannerAgain = 0) => {
  const localStorageLastCloseBannerInstallApp: string =
      localStorage.getItem(BANNER_INSTALL_APP_STORAGE_NAME) || ''

  const dateLocalStorage: Date | string = new Date(
    localStorageLastCloseBannerInstallApp
  )

  return dateLocalStorage == 'Invalid Date' ||
      sumMinutesToDate(dateLocalStorage, timeToShowBannerAgain) < new Date()
}

const promotionCashbackIsActive = (dateStartPromotion = '') => {
  return dayjs().isAfter(dayjs(dateStartPromotion, 'DD/MM/YYYY HH:mm:ss'))
}

export const verifyShouldDisplayBanner =
  (data: BannerData | undefined): boolean => {
    if (
      data?.enableBannerInstallApp &&
      mustDisplayBannerAgain(data?.timeToShowBannerAgain) &&
      data.isOnMobileBrowser &&
      pageIsAllwed()
    ) {
      return true
    }

    return false
  }

export const verifyShouldDisplayBannerWithCashback =
  (data: BannerData | undefined): boolean => {
    const completedCashbackJourney = parseInt(localStorage.getItem(COMPLETED_JOURNEY_STORAGE_KEY_NAME) || '0')

    if (
      data?.enableBannerInstallApp &&
      contextCashbackIsValid(data) &&
      promotionCashbackIsActive(data?.dateStartPromotion) &&
      mustDisplayBannerAgain(data?.timeToShowBannerAgain) &&
      !completedCashbackJourney &&
      pageIsAllwed()
    ) {
      return true
    }

    return false
  }

const contextCashbackIsValid = (
  bannerData: BannerData | null
) => {
  return (
    (bannerData?.isOnMobileApp && !isUserLogged()) ||
      bannerData?.isOnMobileBrowser
  )
}

const isUserLogged = () => {
  const userId = Cookies.get('user_id')
  return !!userId
}

export const clickOnDownload = (
  link: string,
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
) => {
  trackClickOnDownloadButton()
  redirectToDownloadApp(event, link)
}

export const modalOpeningTracking = () => {
  sendToApp({
    event: 'download_app',
    properties: {
      step_name: 'cashback_know_more'
    }
  })
}

export const setTimeToDisplayAgain = () => {
  const timeOfClick = new Date()
  localStorage.setItem(BANNER_INSTALL_APP_STORAGE_NAME, timeOfClick.toString())
}

export type BannerData = {
  enableBannerInstallApp: boolean
  dateStartPromotion: string
  timeToShowBannerAgain: number
  isOnMobileApp: boolean
  isOnMobileBrowser: boolean
  environment: string
  textFirstLineBanner: string
  textSecondLineBanner: string
  textButtonBanner: string
  linkButtonBanner: string
}

type GetBannerResponse = {
  data: BannerData
}

export const loadBannerData = async () => {
  try {
    const resp = await request.get<GetBannerResponse>(
      '/api/v3/app/banner-install-app'
    )
    return resp.data.data
  } catch (error) {
    datadogRum.addError(error)
  }
}
